const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
};

export const getGeoLocation = (
    onSucces: (position: GeolocationPosition) => void,
    onError: (err: GeolocationPositionError) => void
) => {
    navigator.geolocation.getCurrentPosition(onSucces, onError, options);
};
